module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-119.4d4aab12.svg";